import { ReactElement } from 'react';

import { Skeleton } from '@beeline/design-system-react/extracted-styles';

export const BannersSkeleton = (): ReactElement => (
  <Skeleton radius={12} height={82} />
);
